import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.customFields)

export const CUSTOM_FIELDS_INSTANCE = service.instanceKey

export const CUSTOM_FIELDS_ENDPOINTS = {
  BULK_UPLOAD: "/admin/custom_fields/bulk_upload_custom_field",
  DOWNLOAD_BULK_FORM:
    "/admin/custom_fields/view/download_bulk_custom_field_upload_form",
  SELECT: "/admin/custom_fields/select",
  GET_EMPLOYEE_FIELD: "/admin/custom_fields/getemployeefield",
  VIEW_EDIT: "/admin/custom_fields/view/edit",
  GET_GROUPS: "/admin/custom_fields/getgroups",
  CHECK: "/admin/custom_fields/check",
  UPDATE: "/admin/custom_fields/update",
  SELECT_GROUPS: "/admin/custom_fields/selectgroups",
  RENAME_GROUP: "/admin/custom_fields/rename_group",
  DISABLE: "/admin/custom_fields/disable",
  CHECK_GROUP: "/admin/custom_fields/checkgroup",
  ADD: "/admin/custom_fields/add",
} as const

export const customFieldsService = {
  instanceKey: service.instanceKey,

  bulkUpload: (formData: FormData) =>
    service.upload(CUSTOM_FIELDS_ENDPOINTS.BULK_UPLOAD, formData),

  downloadBulkForm: () =>
    service.get(CUSTOM_FIELDS_ENDPOINTS.DOWNLOAD_BULK_FORM),

  select: (params?: Record<string, any>) =>
    service.get(CUSTOM_FIELDS_ENDPOINTS.SELECT, params),

  getEmployeeField: <T = any>(id: string | number, personId: string | number) =>
    service.get<T>(CUSTOM_FIELDS_ENDPOINTS.GET_EMPLOYEE_FIELD, {
      id: String(id),
      person_id: String(personId),
    }),

  viewEdit: (id: string | number) =>
    service.get(CUSTOM_FIELDS_ENDPOINTS.VIEW_EDIT, { id }),

  getGroups: () => service.get(CUSTOM_FIELDS_ENDPOINTS.GET_GROUPS),

  check: (description: string, customFieldId?: string | number) =>
    service.get(CUSTOM_FIELDS_ENDPOINTS.CHECK, {
      description,
      ...(customFieldId !== undefined
        ? { custom_field_id: customFieldId }
        : {}),
    }),

  update: (id: string | number, body: Record<string, any>) =>
    service.post(`${CUSTOM_FIELDS_ENDPOINTS.UPDATE}?id=${id}`, body),

  selectGroups: (body: Record<string, any>) =>
    service.get(CUSTOM_FIELDS_ENDPOINTS.SELECT_GROUPS, body),

  renameGroup: (id: string | number, body: Record<string, any>) =>
    service.post(`${CUSTOM_FIELDS_ENDPOINTS.RENAME_GROUP}?id=${id}`, body),

  disable: (id: string | number, comment: string) =>
    service.post(
      `${CUSTOM_FIELDS_ENDPOINTS.DISABLE}?id=${id}&comment=${comment}`
    ),

  checkGroup: (description: string) =>
    service.get(CUSTOM_FIELDS_ENDPOINTS.CHECK_GROUP, { description }),

  add: (body: Record<string, any>) =>
    service.post(CUSTOM_FIELDS_ENDPOINTS.ADD, body),
}
